module.exports = __webpack_public_path__ + "static/media/HTIJSNAD2.c4c975e0.png";